module.exports = __webpack_public_path__ + "img/gml-logo.ce135703.png";